import { StyledModal } from '@app/components/modal/Modal';
import useLocationActions from '@app/hooks/locations/useLocationActions';
import type { Brand } from '@app/services/api.types';
import type { ModalProps } from 'antd';

export type LocationDeleteModalProps = ModalProps & {
    title?: string;
    data?: Brand;
};

export const LocationDeleteModal = ({
    title = 'Delete Location?',
    data,
    ...props
}: LocationDeleteModalProps) => {
    const { deleteLocation } = useLocationActions();

    return (
        <StyledModal
            title={title}
            maskClosable={false}
            okText="Delete"
            {...props}
            confirmLoading={deleteLocation?.isPending}
            onOk={(e) => {
                const formData = { id: data?.id || 0 };
                deleteLocation.mutate(formData, {
                    onSuccess: () => {
                        if (props?.onOk) {
                            props.onOk(e);
                        }
                    },
                });
            }}>
            <p>Are you sure you want to remove this location?</p>
        </StyledModal>
    );
};

export default LocationDeleteModal;
